var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationFailedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.29075 1.8602L0.820753 16.0002C0.646121 16.3026 0.55372 16.6455 0.552742 16.9947C0.551764 17.3439 0.642244 17.6873 0.81518 17.9907C0.988115 18.2941 1.23748 18.547 1.53846 18.7241C1.83944 18.9012 2.18155 18.9964 2.53075 19.0002H19.4708C19.82 18.9964 20.1621 18.9012 20.463 18.7241C20.764 18.547 21.0134 18.2941 21.1863 17.9907C21.3593 17.6873 21.4497 17.3439 21.4488 16.9947C21.4478 16.6455 21.3554 16.3026 21.1808 16.0002L12.7108 1.8602C12.5325 1.56631 12.2815 1.32332 11.9819 1.15469C11.6824 0.986053 11.3445 0.897461 11.0008 0.897461C10.657 0.897461 10.3191 0.986053 10.0196 1.15469C9.72003 1.32332 9.46902 1.56631 9.29075 1.8602Z",
    fill: "#EB4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 7.75378V10.7799",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 13.8053H11.0092",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailedIcon);
export default __webpack_public_path__ + "static/media/verificationFailedIcon.f5f8510ef5c7958d4084ead4b6538d50.svg";
export { ForwardRef as ReactComponent };